import { Paragraph } from '@zillow/constellation-10';

const WizardTipContent = () => {
  return (
    <div data-testid="WizardTipContent">
      <Paragraph>
        Renters like to see photos of the room they&apos;ll be renting. Consider adding photos of the room, in addition
        to photos of the property&apos;s shared areas.
      </Paragraph>
    </div>
  );
};

export default WizardTipContent;
